fetch(window.navigationURI).then(res => res.json()).then(function(data){
  
	var mobile = new Vue({
		el: '#mobile-menu',
      	delimiters: ["{[{","}]}"],
      	data: {
      		nav: data.links
    	}
	});
  
    var desktop = new Vue({
  		el: '#desktopNav',
      	delimiters: ["{[{","}]}"],
      	data: {
      		nav: data.links,
          	onLink: null,
          	parent: null,
          	subParent: null,
          
    	},
      	mounted: function() {
          	var that = this;
        	var loc = window.location.href;
  			var pathname = window.location.pathname;
          	
          	this.nav.forEach(function(val, i) {
              
              if(val.href == pathname){
                  that.onLink = val.name;
              }
              
              val.parent.forEach(function(p){
                if(p.href == pathname){
                	that.onLink = val.name;
                }
              
              	if(p.parent){
                  p.parent.forEach(function(sub){
                  	if(sub.href == pathname) {
                      	that.onLink = val.name;
                      }
                  });
                }
              
              
              });
              	
          	});
        },
      	methods: {
          addParent: function(nav) {
            if(nav.parent) {
              this.parent = {
                links: nav.parent,
                img: nav.img,
                name: nav.name,
                caption: nav.caption
              };
            }else{
                this.parent = null;
            }
          
          },
          changeSub: function(p, topNav) {
            if(p.img){
                this.parent.img = p.img;
                this.parent.caption = p.caption;
            }

            if(p.parent) {
                this.subParent = p.parent;
            }

            if(!p.parent && this.subParent && topNav) {
                this.subParent = null; 
            }
          
          },
          removeLink: function(p) {
          	this[p] = null;
          }
        }
  	});
  

});